export default __webpack_public_path__ + "static/media/wintercare.a2df679a.jpg";